import { File as UploadFile } from '@moneyforward/ap-frontend-components/dist/es/molecules/Uploader/Drawer/Components/Base/types';

const ReceivedInvoiceReceiptType = {
  paper: 'paper',
  e_doc: 'e_doc',
} as const;

export type ReceiptTypeLabel = keyof typeof ReceivedInvoiceReceiptType;

export type TReceivedInvoiceUpload = {
  files: TUploadFile[];
  receipt_type: ReceiptTypeLabel;
  ap_payee_id: string;
  pic_ids: string[];
};

export type TUploadFile = UploadFile;

export enum RECEIVED_INVOICE_FILE_ERROR {
  INVALID = 'invalid',
  MAX_SIZE = 'max_size',
}
